// Aggregate reads run outside the API Gateway request. Keep this opt-in and
// local to the feedback dashboard; ordinary JMPost callers are unchanged.
export async function feedbackRead(apiClient, path, body, isActive = () => true) {
  const kickoff = await apiClient.JMPost(path, { ...body, background: true });
  if (kickoff?.error) throw new Error(kickoff.error);
  if (!kickoff?.jobId) return kickoff;
  const deadline = Date.now() + 20 * 60 * 1000;
  let failures = 0;
  while (isActive() && Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, 3000));
    if (!isActive()) break;
    let response;
    try {
      response = await apiClient.JMPost("/v1/notes/feedback/reads/status", { jobId: kickoff.jobId });
      failures = 0;
    } catch (error) {
      if (++failures >= 3) throw error;
      continue;
    }
    if (response?.error || response?.status === "failed") throw new Error(response.error || "This section failed. Try again.");
    if (response?.status === "completed") return response.result;
    if (!["queued", "running"].includes(response?.status)) throw new Error("Unexpected job status");
  }
  throw new Error(isActive() ? "This section took too long. Try again." : "Cancelled");
}
